import React, { useEffect, useState } from "react";
import { BedDouble, Bath, Users, MapPin, CalendarDays } from "lucide-react";
import { listRentals } from "../lib/api";
import RentalCalendarDialog from "./RentalCalendarDialog";

const fmtPrice = (p, c) => (p == null ? "Tarif sur demande" : `${new Intl.NumberFormat("fr-FR").format(p)} ${c || "USD"} / nuit`);

export default function RentalsLive() {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(null);

  useEffect(() => {
    listRentals().then(setData).catch(() => setData({ enabled: false, items: [] }));
  }, []);

  if (!data || !data.enabled || data.items.length === 0) return null;

  return (
    <section id="locations-live" className="py-20 glass-light border-t border-white/40" data-testid="rentals-live-section">
      <div className="max-w-6xl mx-auto px-6">
        <div className="mb-12">
          <p className="reveal text-[#2f74c9] tracking-[0.3em] text-xs uppercase mb-3">Disponibles à la location</p>
          <h2 className="reveal font-serif-display text-3xl md:text-4xl text-[#0b1f33]">Nos locations de vacances</h2>
          <p className="reveal reveal-delay-1 text-slate-500 mt-3 max-w-2xl">Disponibilités en temps réel, synchronisées avec Guesty.</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7">
          {data.items.map((l) => (
            <article key={l.id} className="reveal bg-white rounded-lg overflow-hidden border border-slate-100 group" data-testid={`rental-card-${l.id}`}>
              <div className="relative h-56 overflow-hidden bg-slate-100">
                {l.photos[0] && <img src={l.photos[0]} alt={l.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />}
                <span className="absolute bottom-3 left-3 bg-[#0b1f33]/90 text-white text-xs font-600 px-3 py-1.5 rounded-full">{fmtPrice(l.nightly_price, l.currency)}</span>
              </div>
              <div className="p-5">
                <h3 className="font-serif-display text-xl text-[#0b1f33] leading-snug line-clamp-2">{l.title}</h3>
                {l.city && <p className="flex items-center gap-1.5 text-xs text-slate-500 mt-2"><MapPin size={13} className="text-[#2f74c9]" /> {l.city}</p>}
                <div className="flex flex-wrap gap-4 text-sm text-slate-600 mt-4">
                  {l.bedrooms != null && <span className="flex items-center gap-1.5"><BedDouble size={15} className="text-[#2f74c9]" /> {l.bedrooms} ch.</span>}
                  {l.bathrooms != null && <span className="flex items-center gap-1.5"><Bath size={15} className="text-[#2f74c9]" /> {String(l.bathrooms).replace(".", ",")} sdb</span>}
                  {l.accommodates != null && <span className="flex items-center gap-1.5"><Users size={15} className="text-[#2f74c9]" /> {l.accommodates} pers.</span>}
                </div>
                <button onClick={() => setOpen(l)} data-testid={`rental-availability-btn-${l.id}`} className="mt-5 w-full inline-flex items-center justify-center gap-2 border border-[#2f74c9] text-[#2f74c9] hover:bg-[#2f74c9] hover:text-white transition-colors px-5 py-2.5 rounded-sm text-sm font-600">
                  <CalendarDays size={16} /> Voir les disponibilités
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
      {open && <RentalCalendarDialog listing={open} onClose={() => setOpen(null)} />}
    </section>
  );
}
